type RefreshFn = () => Promise<void>;

let refreshFn: RefreshFn | null = null;
let activeRefreshPromise: Promise<void> | null = null;

/**
 * Called by TokenManagerProvider on mount to wire the Descope sdk.refresh()
 * into the non-React Axios interceptor chain.
 */
export function registerTokenRefresh(fn: RefreshFn): void {
  refreshFn = fn;
}

/**
 * Called by TokenManagerProvider on unmount.
 */
export function unregisterTokenRefresh(): void {
  refreshFn = null;
}

/**
 * Attempts a single token refresh, coalescing concurrent callers into one
 * in-flight request. Returns true when the token was successfully refreshed.
 *
 * Safe to call from outside React (e.g. Axios interceptor).
 */
export async function attemptTokenRefresh(): Promise<boolean> {
  if (!refreshFn) {
    return false;
  }

  if (activeRefreshPromise) {
    try {
      await activeRefreshPromise;
      return true;
    } catch {
      return false;
    }
  }

  try {
    activeRefreshPromise = refreshFn();
    await activeRefreshPromise;
    return true;
  } catch {
    return false;
  } finally {
    activeRefreshPromise = null;
  }
}
